import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Grid, Dropdown } from 'semantic-ui-react';
import _ from 'lodash';

import { Filter, Main } from 'Containers/';
import { LUNCH_APPLICATION_WEBSITE_NAME } from 'Common/Constants/website';
import {
  errorToast,
  toastSuccess,
  toastErrorFromCatch,
} from 'Common/ToastHelper';
import { convertEnumToDropdownArray } from 'Common/Constants/Enumeration/ConvertEnumToDropdownArray';
import { LoadingPage } from 'Components/';
import MPWWebApi from 'API/MPWApi';
import * as CaseTypeActions from 'State/caseTypes/actions';
import * as RIAStateCacheSelectors from 'State/pagestatecache/pages/reviewincomingapplications/selectors';

import { IncomingApplicationReasonEnum } from './components/Constants';
import { clearHub } from '../manageapplication/state/hub/actions';
import { ReviewAppGrid } from './components/ReviewAppGrid';
import {
  getApplicationList,
  syncApplications,
  setFilteredData,
} from './state/grid/actions';

class ReviewIncomingApplicationsContainer extends Component {
  state = {
    lapButtonDisabled: false,
  };

  getMainProps = () => {
    return {
      toolbox: {
        shown: false,
      },
    };
  };

  componentDidMount() {
    const {
      getApplicationList,
      clearHub,
      getCaseTypes,
      savedState,
    } = this.props;

    if (_.isNil(savedState)) {
      getApplicationList();
      clearHub();
      getCaseTypes();
    }
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'syncError');
  }

  onFilterChange = (e, data) => {
    this.props.setFilteredData(data.value);
  };

  getDropdownData() {
    return convertEnumToDropdownArray(IncomingApplicationReasonEnum, true);
  }

  processScannedApplications = async () => {
    const { getApplicationList } = this.props;
    this.setState({ processingScannedApplications: true });

    try {
      const response = await MPWWebApi.getGeneric(
        `IncomingApplication/ProcessScannedApplications`
      );
      toastSuccess(response.data.Data);
      getApplicationList();
    } catch (error) {
      toastErrorFromCatch(error);
    }

    this.setState({ processingScannedApplications: false });
  };

  render() {
    const {
      syncLoading,
      fetching,
      syncApplications,
      getApplicationList,
      selectedFilter,
      filteredApplicationData,
      history,
    } = this.props;

    const { processingScannedApplications } = this.state;

    if (fetching) return <LoadingPage message={'Loading...'} />;

    return (
      <Fragment>
        <Filter title={'Review Incoming Applications'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={6}>
                <Button
                  secondary
                  onClick={syncApplications}
                  loading={syncLoading}
                  disabled={syncLoading}
                >
                  Download Applications From &nbsp;
                  {LUNCH_APPLICATION_WEBSITE_NAME}
                </Button>
              </Grid.Column>
              <Grid.Column width={6}>
                <Button
                  secondary
                  onClick={this.processScannedApplications}
                  loading={processingScannedApplications}
                  disabled={processingScannedApplications}
                >
                  Process Scanned Applications
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row>
              <Grid.Column width="6">
                <Dropdown
                  placeholder="Filter Option"
                  fluid
                  selection
                  options={this.getDropdownData()}
                  onChange={this.onFilterChange}
                  value={selectedFilter}
                />
              </Grid.Column>
              <Grid.Column width={'2'}>
                <Button
                  secondary
                  icon="refresh"
                  onClick={getApplicationList}
                  loading={syncLoading}
                  disabled={syncLoading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <ReviewAppGrid
            fetching={fetching}
            data={filteredApplicationData}
            history={history}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    ReviewIncomingApplicationsState: { grid },
  } = state;

  return {
    filteredApplicationData: grid.filteredApplicationData,
    fetching: grid.fetching,
    processingScannedApplications: grid.processingScannedApplications,
    syncLoading: grid.syncLoading,
    syncError: grid.syncError,
    selectedFilter: grid.selectedFilter,
    savedState: RIAStateCacheSelectors.getReviewIncAppsState(state),
  };
};

export const ReviewIncomingApplications = withRouter(
  connect(mapStateToProps, {
    getApplicationList,
    syncApplications,
    setFilteredData,
    clearHub,
    getCaseTypes: CaseTypeActions.getCaseTypes,
  })(ReviewIncomingApplicationsContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/ReviewIncomingApplications.js